import config from 'crm/config'

const profileApi = `${config.apiHost}/oem-profile`

export default {
    getJoinGroupWay: {
        url: `${profileApi}/api/groupchat/join_way`,
        type: 'GET',
    },

    setJoinGroupWay: {
        url: `${profileApi}/api/groupchat/join_way`,
        type: 'PUT',
    },
}
